export enum ProductVisibilityScope {
	B2c = "B2c",
	B2b = "B2b",
	B2cAndB2b = "B2cAndB2b",
	FathersChoice = "FathersChoice",
	FfcMembersOnly = "FfcMembersOnly",
}
